<template>
    <div class="view-password">
        <div class="subtitle-1 text-center">
            Login using email and password
        </div>
        <v-card-text>
            <v-form>
                <v-text-field
                    v-model="form.login"
                    label="Login"
                    name="login"
                    prepend-icon="person"
                    type="text"
                    color="primary darken-4"
                    :rules="rules.login"
                    :loading="loading"
                    autofocus
                ></v-text-field>

                <v-text-field
                    v-model="form.password"
                    id="password"
                    label="Password"
                    name="password"
                    prepend-icon="lock"
                    color="primary darken-4"
                    :loading="loading"
                    :rules="rules.password"
                    :append-icon="passwordMode ? 'visibility_off' : 'visibility'"
                    @click:append="() => (passwordMode = !passwordMode)"
                    :type="passwordMode ? 'password' : 'text'"
                    v-on:keyup.enter="canLogin ? login() : false"
                ></v-text-field>

                <v-checkbox
                  v-model="form.remember"
                  label="Remember me"
                  class="ml-7"
                ></v-checkbox>
            </v-form>
        </v-card-text>
        <v-card-actions
            class="d-flex flex-wrap last-selected">
            <v-btn text small color="black--text"
                   to="/password/reset">
                Forgot your password?
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn large
                   text
                   @click="back()">
                Back
            </v-btn>
            <v-btn large
                   color="primary darken-4 white--text"
                   :disabled="loading || !canLogin"
                   @click="login">
                Login
            </v-btn>
        </v-card-actions>
        <v-overlay :value="loading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-row justify="center">
            <v-dialog v-model="error" persistent max-width="290">
                <v-card>
                    <v-card-title class="headline">Login failed</v-card-title>
                    <v-card-text>
                        Login details didn't match our records.<br/>
                        Please check your details and try again.
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="black" text @click="error = false">OK</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </div>
</template>

<script>
    import {passwordMixin} from '../mixins/password'

    export default {
        name: "Password",
        mixins: [passwordMixin]
    }
</script>

<style scoped>

</style>
